import React, { useEffect, useState } from 'react';
import useWorkflowOrgConfig from '../../../../../../hook/useWorkflowOrgConfig';
import PaymentInfor from '../../../../../phan-he-vien-phi/components/PaymentInfor';
import { WORKFLOW_ORG_CONFIG_CODE } from '../../../../../utils/Constant';
import { formatMoney } from '../../../../../utils/FormatUtils';
import { calculateServicePrice } from '../../../../utils/Utils';

type Props = {
	tableData: any[];
	generalInfo: any;
};

const OrderAmount = ({ tableData, generalInfo }: Props) => {
	const { config: paymentConfig } = useWorkflowOrgConfig({
		code: WORKFLOW_ORG_CONFIG_CODE.FORM_INFO_PAYMENT_ASSIGN,
	});
	const [paymentItem, setPaymentItem] = useState<any>([]);
	const { visit } = generalInfo ?? {};

	const thongTinChiPhi = {
		tongChiPhi: visit?.ttTong,
		bhyt: visit?.ttBhyt,
		benhNhan: visit?.ttNguoiBenh,
		tamUng: visit?.ttTamUng,
		daThu: visit?.ttDaThu,
		mienGiam: visit?.ttDiscountInv,
		conDu: visit?.ttConDu,
	};
	const tongTienDonThuoc = tableData.reduce((acc: number, row: any) => {
		return acc + (row.thanhTien || 0);
	}, 0);

	useEffect(() => {
		handleSetPaymentInfor(paymentConfig);
	}, [tongTienDonThuoc, paymentConfig]);

	const handleSetPaymentInfor = async (config: any[]) => {
		const paymentByConfig = calculateServicePrice(
			thongTinChiPhi,
			tableData,
			'thanhTien',
			config
		);
		setPaymentItem(paymentByConfig);
	};

	return (
		<div className="d-flex align-items-center w-75">
			<div className="border-right h-100 min-w-100 spaces pr-30 d-flex align-items-center justify-content-center flex-column">
				<div className="fw-bold mt-2 text-danger">Tiền đơn</div>
				<div className="text-danger fw-bold text-center">
					{formatMoney(tongTienDonThuoc)}
				</div>
			</div>

			<PaymentInfor className="w-100 price-info" paymentData={paymentItem} />
		</div>
	);
};

export default OrderAmount;
